import { all } from "@redux-saga/core/effects";
import lmsReportsWatcherSaga from "@timhortons/common/src/redux/lmsReports/saga/lmsReports";
import detailedLmsReportsWatcherSaga from "@timhortons/common/src/redux/lmsReports/saga/detailedLmsReports";

export default function* lmsReportsRootSaga() {
  yield all([lmsReportsWatcherSaga(), detailedLmsReportsWatcherSaga()]);
}
